import { Stack, StackDivider } from '@chakra-ui/react';
import { DetailsCard } from './cards/DetailsCard';
import { AddressCard } from './cards/AddressCard';
import { ContactsCard } from './cards/ContactsCard';
import { StatusCard } from './cards/StatusCard';
import { CoursesCard } from './cards/CoursesCard';
import type { EmployerDetail } from './types';

export function EmployerDetailsTab({ employer }: { employer: EmployerDetail }): React.ReactElement {
  return (
    <Stack gap={6} p={4} divider={<StackDivider borderColor="border.default" />}>
      <DetailsCard employer={employer} />
      <AddressCard employer={employer} />
      <ContactsCard employer={employer} />
      <StatusCard employer={employer} />
      <CoursesCard employerId={employer.id} />
    </Stack>
  );
}
